import { useNavigate } from "#routers/hooks";
import { useIsFeatureAvailable } from "#src/contexts/AuthenticatedContext.helpers";
import { linkToInsightsDetails } from "#src/routes/dashboard/insights/[insightsId]/details";
import { useQuery } from "@tanstack/react-query";
import { CardGrid } from "@validereinc/common-components";
import { Insights, InsightsAdapterQueryKeys } from "@validereinc/domain";
import { FeatureFlags, PermissionsMap } from "@validereinc/domain-controllers";
import { dateFormatter } from "@validereinc/utilities";
import React from "react";

export const InsightsDashboardTab = () => {
  const navigate = useNavigate();

  const [shouldUseV2Insights] = useIsFeatureAvailable({
    featureFlagQuery: {
      $and: [FeatureFlags.DashboardsManageInsights],
    },
    permissionQuery: PermissionsMap.InsightsDashboardsRead,
  });

  const { data: dashboardsData, isLoading: isLoadingDashboards } = useQuery({
    queryKey: InsightsAdapterQueryKeys.getDashboards({}),
    queryFn: () => Insights.getDashboards({}),
    enabled: !shouldUseV2Insights,
  });

  const { data: dashboardsDataV2, isLoading: isLoadingDashboardsV2 } = useQuery(
    {
      queryKey: InsightsAdapterQueryKeys.getDashboardsV2({}),
      queryFn: () => Insights.getDashboardsV2({}),
      enabled: shouldUseV2Insights,
    }
  );

  const onPrimaryCardClick = (id: string) => {
    navigate({ pathname: linkToInsightsDetails(id) });
  };

  const dashboards = shouldUseV2Insights ? dashboardsDataV2 : dashboardsData;
  const isLoading = shouldUseV2Insights
    ? isLoadingDashboardsV2
    : isLoadingDashboards;

  return (
    <CardGrid
      items={dashboards ?? []}
      onPrimaryCardClick={onPrimaryCardClick}
      hasCta={false}
      isLoading={isLoading}
      getMeta={({ updatedAt }: { updatedAt?: Date }) => {
        if (updatedAt) {
          return `Last updated: ${dateFormatter(updatedAt)}`;
        }

        return "";
      }}
    />
  );
};
